import { Grid, Tab, Tabs, Box } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import React, { useState, useEffect } from "react";
import { useAuth } from "../../../../context";
import Chip from "@mui/material/Chip";
import useFetchObjects from "../../../../api/useFetchObjects";
import { useTranslation } from "react-i18next";

const tabStyle = {
  textTransform: "capitalize",
};

const PatientList = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);
  const auth = useAuth();
  const token = auth?.user?.token;
  const [status, setStatus] = useState("");

  const { data, refetch, isLoading, isError } = useFetchObjects(
    ["appointments"],
    `appointments/?status=${status}`,
    token,
  );

  useEffect(() => {
    refetch();
  }, [status, refetch]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      setStatus("");
    } else if (newValue === 1) {
      setStatus(1);
    } else if (newValue === 2) {
      setStatus(2);
    }
  };

  const getChipColor = (status) => {
    return status === 1
      ? "orange"
      : status === 2
        ? "green"
        : status === 3
          ? "blue"
          : "grey";
  };

  return (
    <Grid container justifyContent={"center"} mb={4} pb={5}>
      <Grid item xs={12}>
        <Grid padding={"0px 25px"} backgroundColor="white" pt={2}>
          <Tabs value={value} onChange={handleChange}>
            <Tab style={tabStyle} label={t("finance.allPatients")} />
            <Tab style={tabStyle} label={t("finance.pending")} />
            <Tab style={tabStyle} label={t("finance.paid")} />
          </Tabs>
        </Grid>

        {isLoading ? (
          <Box>{t("finance.loading")}</Box>
        ) : isError ? (
          <Box color="red">{t("finance.errorFetchingData")}</Box>
        ) : (
          <TableContainer
            sx={{ padding: "25px", boxShadow: "0px 0px 0px", pb: 4 }}
            component={Paper}
          >
            <Table
              sx={{ minWidth: 650, border: "1px solid #dbd8ce" }}
              aria-label="simple table"
            >
              <TableHead style={{ backgroundColor: "#f2f2f2" }}>
                <TableRow style={{ fontWeight: "bold" }}>
                  <TableCell align="center">{t("finance.time")}</TableCell>
                  <TableCell align="center">{t("finance.date")}</TableCell>
                  <TableCell align="center">
                    {t("finance.patientName")}
                  </TableCell>
                  <TableCell align="center">{t("finance.doctor")}</TableCell>
                  <TableCell align="center">{t("finance.fees")}</TableCell>
                  <TableCell align="center">{t("finance.due")}</TableCell>
                  <TableCell align="center">{t("finance.status")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.results?.map((patient, i) => (
                  <TableRow
                    key={i}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="center">{patient.timeOfVisit}</TableCell>
                    <TableCell align="center">{patient.dateOfVisit}</TableCell>
                    <TableCell align="center">
                      {patient.patient_name_display}{" "}
                      {patient.patient_lastname_display}
                    </TableCell>
                    <TableCell align="center">
                      {patient.doctor_name_display}{" "}
                      {patient.doctor_lastname_display}
                    </TableCell>
                    <TableCell align="center">{patient.fees}</TableCell>
                    <TableCell align="center">{patient.due}</TableCell>
                    <TableCell align="center">
                      <Chip
                        label={patient.status_display}
                        sx={{
                          backgroundColor: getChipColor(patient.status),
                          color: "white",
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Grid>
    </Grid>
  );
};

export default PatientList;
